import ProductsCatchAll, { createStaticProps } from '@/lib/catchAllRoutes';
import { GetStaticProps } from 'next';
export default ProductsCatchAll;
export { getStaticPaths } from '@/lib/catchAllRoutes';

export const getStaticProps: GetStaticProps = async (context) => {
  return await createStaticProps(context, 'categories');
};
